import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import Image from '../Image';

const FullPicture = (props) => {
    return <div className="preview-full">
            <div className="switch-full">
                <Link className="button" to={props.beforeElem}>Précédente</Link>
                <Link className="button" to={props.nextElem}>Suivante</Link>
            </div>
            <a href={props.urlDownload} target="_urlDownload" title="Télécharger"><Image url={props.url} className="img-preview-full" /></a>
            <label>{props.label}</label>
        </div>;
}

FullPicture.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.string
}

export default FullPicture;